<script setup>
import { ref, computed } from 'vue';
import Project130 from "@/components/Projects/Project130.vue";

const competitionId = computed(() => {
  return window.competitionId
})

</script>

<template>
  <div>
	  <template v-if="competitionId === '130'">
      <Project130 />
	  </template>
  </div>
</template>

<style lang="scss" scoped>

</style>